module.exports = __webpack_public_path__ + "static/img/dataRetrieval.45854ea0.png";